/**
 * Default mobile pages shared by all tenants until overridden in
 * mobile/{tenantKey}/pages/.
 */
import MobileInfoSite from "mobile/public/MobileInfoSite";
import MobileQrDeal from "mobile/public/MobileQrDeal";
import MobileQrScan from "mobile/public/MobileQrScan";
import CatalogPage from "storefronts/vbsus/pages/CatalogPage";
import ProductDetailPage from "storefronts/vbsus/pages/ProductDetailPage";
import CartPage from "storefronts/vbsus/pages/CartPage";
import CheckoutPage from "storefronts/vbsus/pages/CheckoutPage";
import {
  MobilePortalAddresses,
  MobilePortalCoreReturn,
  MobilePortalCoreReturns,
  MobilePortalDistributorCustomers,
  MobilePortalDistributorRequestDetail,
  MobilePortalDistributorRequests,
  MobilePortalHome,
  MobilePortalOrderDetail,
  MobilePortalOrders,
  MobilePortalProfile,
  MobilePortalValveBodies,
  MobilePortalValveBodyDetail,
  MobilePortalWarrantyChat,
  MobilePortalWarrantyClaim,
  MobilePortalWarrantyCreate,
} from "mobile/portal/MobilePortal";
import {
  MobilePortalSupport,
  MobilePortalSupportCompose,
  MobilePortalSupportThread,
} from "mobile/portal/MobilePortalSupport";

/** @type {Partial<import('../types').MobileTenantModule['pages']>} */
export const SHARED_MOBILE_PAGES = {
  home: MobileInfoSite,
  download: MobileInfoSite,
  qrDeal: MobileQrDeal,
  qrScan: MobileQrScan,
  catalog: CatalogPage,
  productDetail: ProductDetailPage,
  cart: CartPage,
  checkout: CheckoutPage,
  portalHome: MobilePortalHome,
  portalOrders: MobilePortalOrders,
  portalOrderDetail: MobilePortalOrderDetail,
  portalDistributorRequests: MobilePortalDistributorRequests,
  portalDistributorRequestDetail: MobilePortalDistributorRequestDetail,
  portalDistributorCustomers: MobilePortalDistributorCustomers,
  portalValveBodies: MobilePortalValveBodies,
  portalValveBodyDetail: MobilePortalValveBodyDetail,
  portalCoreReturns: MobilePortalCoreReturns,
  portalCoreReturn: MobilePortalCoreReturn,
  portalWarrantyCreate: MobilePortalWarrantyCreate,
  portalWarrantyClaim: MobilePortalWarrantyClaim,
  portalWarrantyChat: MobilePortalWarrantyChat,
  portalSupport: MobilePortalSupport,
  portalSupportCompose: MobilePortalSupportCompose,
  portalSupportThread: MobilePortalSupportThread,
  portalProfile: MobilePortalProfile,
  portalAddresses: MobilePortalAddresses,
};

export default {
  key: "shared",
  label: "Shared default",
  pages: SHARED_MOBILE_PAGES,
};
